import axios from "axios";
import { forwardRef, useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import { Oval } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../reducer/alertSlice";
import SelectBox from "./SelectBox";

const AddIp = forwardRef(({addValue, removeValue, addedArr=[], ...props},ref) => {
    const [ipType, setIpType] = useState(0);
    const [ip, setIp] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [registration, setRegistration] = useState(null);

    const dispatch = useDispatch();

    const checkExists = (value) => {
        let isExists = false;
        // 중복 검사
        // 1. 해당 페이지에서 추가된 번호와 동일한지 확인
        addedArr.forEach((el, idx) => {
            if (el == value) {
                isExists = true;
            }
        });
        return isExists;
    }

    return (
        <InputGroup>
            <input name="ip-addr" className="form-control" 
                    readOnly={ipType == 0 ? true : false} value={ip} 
                    ref={ref}
                    placeholder={ipType == 0 ? "IP 주소를 조회하세요" : "IP 주소를 입력하세요"}
                    onChange={(e) => {
                        setIp(e.target.value);
                    }} 
                    onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"0-9]/g, "");
                        if (registration) {
                            if (registration != e.target.value) {
                                removeValue(registration);
                                setRegistration(null);
                            }
                        }
                    }}
            />

            <SelectBox 
                defaultValue="0"
                style={{width: "80px"}}
                data={[
                {
                    label: "자동",
                    value: "0"
                },
                {
                    label: "수동",
                    value: "1"
                },
            ]}
            onChange={(value) => {
                setIpType(value.value);
                removeValue(registration);
                setRegistration(null);
                // 자동일 시 ip값 초기화
                if (value.value == 0) {
                    setIp("");
                }
            }}
            >

            </SelectBox>
            {
            ipType == 0 ?
            <Button style={{width: "60px"}} className="d-flex justify-content-center" 
            disabled={isLoading ? true : false} onClick={() => {
                setIsLoading(true);
                axios("/ip", {
                    method: "GET"
                }).then(result => {
                    setIsLoading(false);
                    if (result.data.code == 0) {
                        const isExists = checkExists(result.data.data);
                        if (isExists) {
                            dispatch(showAlert({
                                msg: "이미 등록된 IP입니다."
                            }))
                        } else {
                            setIp(result.data.data);
                            addValue(result.data.data);
                            setRegistration(result.data.data);
                        }
                    } else {
                        dispatch(showAlert({
                            msg: <>처리 중 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요</>
                        }))
                    }
                }) 
            }}>
                {isLoading ? <Oval height={20} width={20} color="#fff" secondaryColor="rgba(255,255,255,0.5)" ariaLabel="oval-loading" /> : "조회"}
            </Button>    
            :
            <Button className="d-flex justify-content-center" 
            disabled={(ip.length > 0 && !registration) ? false : true} onClick={() => {
                const filter = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
                if (filter.test(ip)) { // IP 형식 확인
                    const isExists = checkExists(ip);
                    if (isExists) {
                        dispatch(showAlert({
                            msg: "이미 등록된 IP입니다."
                        }))
                    } else {
                        setRegistration(ip);
                        addValue(ip);
                    }
                } else {
                    dispatch(showAlert({
                        msg: <>유효하지 않은 IP 주소입니다.<br/>다시 한 번 확인해주세요.</>
                    }))
                }
            }}>
                {
                    registration ?
                    "완료"
                    : 
                    "등록"
                }
            </Button>    
            }
        </InputGroup>
    )
})

export default AddIp;